import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { FeedEvent } from '@urbanmix-tech/shared-js';
import { convertPseudoDateToRealDate } from '@/helpers/common';

interface FeedEventDetailsModalProps {
  open: boolean;
  onClose: () => void;
  event: FeedEvent | null;
}

const renderObject = (obj: Record<string, any>) => {  
  return Object.keys(obj).map((key: string) => {
    console.log(obj[key]);
    if (Array.isArray(obj[key])) {
      return (
        <Typography variant="body1">
          {`${key}`}
          {obj[key].map((item: string, index: number) =>
            renderObject({ [index]: item })
          )}
        </Typography>
      );
    } else if (typeof obj[key] === 'object') {
      return (
        <Typography variant="body1">
          {`${key}`}
          {Object.keys(obj[key]).map((subKey: string) =>
            renderObject({ [subKey]: obj[key][subKey] })
          )}
        </Typography>
      );
    }
    return (
      <Typography variant="body1">
        {key} : {obj[key]}
      </Typography>
    );
  });
};

export function FeedEventDetailsModal({
  open,
  onClose,
  event,
}: FeedEventDetailsModalProps) {
  if (!event) {
    return null;
  }

  const date = convertPseudoDateToRealDate(event.eventDate);
  const isTaskComment = event.eventType === 'task_comment';

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {isTaskComment
          ? `Comment on: ${event.eventData?.taskTitle || 'Task'}`
          : event.eventData.title ?? 'Feed Event Details'}
      </DialogTitle>
      <DialogContent>
        {isTaskComment ? (
          // Special rendering for task comments
          <>
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>Author:</strong> {event.eventData?.authorName || 'Unknown'}
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>Date:</strong> {date?.toLocaleDateString()}{' '}
              {date?.toLocaleTimeString()}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Comment:</strong>
            </Typography>
            <Typography
              variant="body2"
              sx={{
                p: 2,
                backgroundColor: 'rgba(39, 39, 42, 0.5)',
                borderRadius: 1,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word'
              }}
            >
              {event.eventData?.comment}
            </Typography>
            {event.eventData?.taskId && (
              <Typography variant="caption" sx={{ mt: 2, display: 'block', color: 'text.secondary' }}>
                Task ID: {event.eventData.taskId}
              </Typography>
            )}
          </>
        ) : (
          // Default rendering for other event types
          <>
            <Typography variant="body1">
              <strong>Event Type:</strong> {event.eventType}
            </Typography>
            <Typography variant="body1">
              <strong>Event Date:</strong> {date?.toLocaleDateString()}{' '}
              {date?.toLocaleTimeString()}
            </Typography>
            {event.eventData && (
              <>
                {Object.keys(event.eventData).map((key: string) =>
                  {
                    return renderObject({[key]: event.eventData[key] })
                  }
                )}
              </>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
